var render, staticRenderFns
import script from "./TableButtons.vue?vue&type=script&lang=js"
export * from "./TableButtons.vue?vue&type=script&lang=js"
import style0 from "./TableButtons.vue?vue&type=style&index=0&id=63043578&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/i18n/template/components/TableButtons.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FVolumes%2FSSD%2Fjenkins_workspace%2Fworkspace%2FJL_UAT_OPERATION%2Fsrc%2Fcomponents%2FTableButtons.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports